import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "v-dialog bd-scale scroll" }
const _hoisted_2 = { class: "v-dialog__button-header on-mobile" }

import { useDialogStore } from '@/stores/dialogs';
import CloseIcon from '@/components/icons/navigation/CloseIcon.vue'
import LeftArrowIcon from '@/components/icons/navigation/LeftArrowIcon.vue'
import { useKeyDownStore } from '@/stores/key-down';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheDialogBase',
  setup(__props) {

const dialogStore = useDialogStore()

useKeyDownStore().watch("Escape", () => dialogStore.length > 0, () => {
  dialogStore.back()
})

let mouseDown = false
const onMouseDown = (e: MouseEvent) => {
  mouseDown = e.target === e.currentTarget
}
const onMouseUp = (e: MouseEvent) => {
  if (!mouseDown || e.target !== e.currentTarget) {
    mouseDown = false
    return
  }
  dialogStore.back()
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_unref(dialogStore).length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "v-dialog-backdrop",
              onMousedown: onMouseDown,
              onMouseup: onMouseUp
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialogStore).dialogHistory, (dialog, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(dialogStore).back && _unref(dialogStore).back(...args)))
                    }, [
                      _createVNode(LeftArrowIcon),
                      _createTextVNode("Back")
                    ])
                  ]),
                  (_openBlock(), _createBlock(_resolveDynamicComponent(dialog.dialog), _normalizeProps(_guardReactiveProps(dialog.props)), null, 16)),
                  _createElementVNode("button", {
                    class: "close-icon",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(dialogStore).close && _unref(dialogStore).close(...args)))
                  }, [
                    _createVNode(CloseIcon)
                  ])
                ], 512)), [
                  [_vShow, index === _unref(dialogStore).length-1]
                ])
              }), 256))
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})